import { render, screen } from "@testing-library/react";
import SegmentFilter from "./SegmentFilter";

test("check rendering range filter", () => {
  render(<SegmentFilter onFilterchange={() => {}} />);
  expect(screen.getByText("Segment")).toBeInTheDocument();
});
